import PropTypes from 'prop-types';
import React, { useState, useEffect } from "react";

import { connect, useDispatch, useSelector } from "react-redux";
// import { Form, Input, Button, Row, Col } from "reactstrap";

// import { Link } from "react-router-dom";

// Reactstrap
// import { Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";

// Import menuDropdown
// import LanguageDropdown from "../CommonForBoth/TopbarDropdown/LanguageDropdown";
// import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";

import logoSm from "../../assets/images/logo-sm.png";
import logoDark from "../../assets/images/logo-dark.png";
import logoLight from "../../assets/images/logo-light.png";

// import images
// import github from "../../assets/images/brands/github.png";
// import bitbucket from "../../assets/images/brands/bitbucket.png";
// import dribbble from "../../assets/images/brands/dribbble.png";
// import dropbox from "../../assets/images/brands/dropbox.png";
// import mail_chimp from "../../assets/images/brands/mail_chimp.png";
// import slack from "../../assets/images/brands/slack.png";

//i18n
import { withTranslation } from "react-i18next";



// Redux Store
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
  getInvoiceAlertInfo,
  setInvoiceAlertOpen as invoiceAlertOpenFirstFirst
} from "../../store/actions";

const Header = props => {
  const dispatch = useDispatch();

  const [search, setsearch] = useState(false);
  const [socialDrp, setsocialDrp] = useState(false);

  const [invoiceAlertOpen, setInvoiceAlertOpen] = useState(false);

  const { invoiceAlertOpenFirst, invoiceAlertInfo} = useSelector(state => ({
      invoiceAlertOpenFirst: state.Settings.invoiceAlertOpenFirst,
      invoiceAlertInfo: state.Settings.invoiceAlertInfo
    }));
  

  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  function tToggle() {
    var body = document.body;
    body.classList.toggle("vertical-collpsed");
    body.classList.toggle("sidebar-enable");
  }

  useEffect(() => {
    dispatch(getInvoiceAlertInfo())

    if (invoiceAlertOpenFirst) {
      // console.log("invoiceAlertOpenFirst is true")
    } else {
      // console.log("invoiceAlertOpenFirst is false")
    }

  }, []);

  useEffect(() => {
    if (invoiceAlertInfo && invoiceAlertInfo.alertsCount > 0 && invoiceAlertInfo.overdueAlerts?.length > 0) {
      setInvoiceAlertOpen(true)
    } else {
      setInvoiceAlertOpen(false)
    }

  }, [invoiceAlertInfo]);

  // console.log(invoiceAlertOpenFirst,invoiceAlertOpen, invoiceAlertInfo)

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header" style={{alignItems: 'flex-start'}}>
          <div className="d-flex">
            <div className="navbar-brand-box">
              <a href="https://www.wecrest.com" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logoSm} alt="" height="22" />
                </span>
                <span className="logo-lg">
                  <img src={logoDark} alt="" height="25" />
                </span>
              </a>

              <a href="https://www.wecrest.com" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logoSm} alt="" height="22" />
                </span>
                <span className="logo-lg">
                  <img src={logoLight} alt="" height="25" />
                </span>
              </a>
            </div>

            <button
              type="button"
              onClick={() => {
                tToggle();
              }}
              className="btn btn-sm px-3 font-size-16 header-item waves-effect vertical-menu-btn"
              id="vertical-menu-btn"
            >
              <i className="fa fa-fw fa-bars" />
            </button>
          </div>
          <div className="d-flex" style={
            (
              invoiceAlertInfo 
              && invoiceAlertInfo.alertsCount
              && invoiceAlertInfo.alertsCount > 0 
              && (invoiceAlertOpenFirst || invoiceAlertOpen)
            ) ? {flex: 1} : {}}
          >
            {
              (invoiceAlertInfo && invoiceAlertInfo.alertsCount && invoiceAlertInfo.alertsCount > 0) ? (
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  flex: invoiceAlertOpenFirst || invoiceAlertOpen ? 1 : 'auto',
                  marginInline: '12px',
                  paddingInline: '10px',
                  backgroundColor: '#F8EDB7',
                  justifyContent: 'space-between',
                  marginBlock: "10px",
                  borderRadius: "5px"
                }}>
                  {
                    ((invoiceAlertOpenFirst || invoiceAlertOpen) && invoiceAlertInfo.alertsCount == 1) ? 
                    <h5 className="col-form-label" style={{textAlign: 'center', width: '100%'}}>
                      {
                        invoiceAlertInfo?.overdueAlerts?.length > 0 ?
                         <>
                          Reminder: your invoice &nbsp;
                          <a href={invoiceAlertInfo?.overdueAlerts[0].invoicePdfUrl} target='_blank'>
                            {invoiceAlertInfo?.overdueAlerts[0].invoiceNo} 
                          </a>
                         &nbsp; is overdue. Please complete the payment to continue using all features. 
                         </>
                        : invoiceAlertInfo?.duesoonAlerts?.length > 0 ?
                          <>
                            Reminder: your invoice &nbsp;
                            <a href={invoiceAlertInfo?.duesoonAlerts[0].invoicePdfUrl} target='_blank'>
                              {invoiceAlertInfo?.duesoonAlerts[0].invoiceNo} </a>
                              &nbsp;is due on {invoiceAlertInfo?.duesoonAlerts[0].deadline}.
                          </>
                        :  <></>
                      }
                    </h5>
                    : ((invoiceAlertOpenFirst || invoiceAlertOpen) && invoiceAlertInfo.alertsCount > 1) ?
                     <div>
                        {
                        invoiceAlertInfo?.overdueAlerts?.length > 0 && invoiceAlertInfo?.duesoonAlerts?.length == 0 &&
                         <p style={{display: 'flex', flexDirection:'column', margin:'0', padding:'0'}}>
                          <p style={{ margin:'0', padding:'0'}}>
                            Reminder: Please complete payment of overdue invoices to continue using all features:&nbsp;
                          </p>
                          <p style={{display: 'flex', flexDirection: 'column', margin:'0', padding:'0', textAlign: 'right', width: '102%'}}>
                            {
                              invoiceAlertInfo?.overdueAlerts.map((alert, index) => (
                                <span key={alert.invoiceNo}>
                                  <a href={alert.invoicePdfUrl} target='_blank'>
                                    {alert.invoiceNo} 
                                  </a>
                                </span>
                              ))
                            }
                          </p>
                         </p>
                        }
                        {invoiceAlertInfo?.duesoonAlerts?.length > 0 && invoiceAlertInfo?.overdueAlerts?.length == 0 &&
                          <p style={{display: 'flex', margin:'0', padding:'0'}}>
                            <p style={{ margin:'0', padding:'0'}}>
                              Reminder: Upcoming invoice payments with due dates:&nbsp;
                            </p>
                            <p style={{display: 'flex', flexDirection: 'column', margin:'0', padding:'0'}}>
                              {
                                invoiceAlertInfo?.duesoonAlerts.map((alert, index) => (
                                  <span key={alert.invoiceNo}>
                                    <a href={alert.invoicePdfUrl} target='_blank'>
                                      {alert.invoiceNo} 
                                    </a>
                                    - {alert.deadline}
                                  </span>
                                ))
                              }
                            </p>
                         </p>
                        }
                        {
                        invoiceAlertInfo?.overdueAlerts?.length > 0 && invoiceAlertInfo?.duesoonAlerts?.length > 0 &&
                         <p style={{display: 'flex', flexDirection:'column', margin:'0', padding:'0'}}>
                          <p style={{ margin:'0', padding:'0'}}>
                            Reminder: Please complete payment of invoices to continue using all features:&nbsp;
                          </p>
                          <p style={{display: 'flex', flexDirection: 'column', margin:'0', padding:'0', marginLeft: '50%'}}>
                            {
                              invoiceAlertInfo?.overdueAlerts.map((alert, index) => (
                                <span key={alert.invoiceNo}>
                                  <a href={alert.invoicePdfUrl} target='_blank'>
                                    {alert.invoiceNo}
                                  </a>
                                  &nbsp;- Overdue
                                </span>
                              ))
                            }
                            {
                                invoiceAlertInfo?.duesoonAlerts.map((alert, index) => (
                                  <span key={alert.invoiceNo}>
                                    <a href={alert.invoicePdfUrl} target='_blank'>
                                      {alert.invoiceNo}
                                    </a>
                                    &nbsp;- Due on {alert.deadline}
                                  </span>
                                ))
                              }
                          </p>
                         </p>
                        }
                     </div>
                      : <></>
                  }   
                  <span
                    onClick={() => {
                      if (invoiceAlertInfo?.overdueAlerts?.length > 0) {
                        setInvoiceAlertOpen(true)
                        return;
                      }
                      console.log("click alert button")
                      setInvoiceAlertOpen(invoiceAlertOpenFirst ? false : !invoiceAlertOpen)
                      dispatch(invoiceAlertOpenFirstFirst(false))
                    }}
                    style={{cursor: 'pointer', position: 'relative', display: "inline-block"}}
                  >
                    <i className="uil uil-bell font-size-24"></i>
                    {
                      !(invoiceAlertOpenFirst || invoiceAlertOpen) && 
                      <span 
                        class="notification-dot"
                        style={{
                          position: 'absolute',
                          top: '2px',
                          right: '2px',
                          width: '10px',
                          height: '10px',
                          backgroundColor: '#ff3b30',
                          borderRadius: '50%',
                        }}
                      >
                      </span>
                    }
                  </span>
                </div>
              ) : null
            }
            <ProfileMenu />
          </div>
        </div>
      </header>
      
    </React.Fragment>
  );
};

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func
};

const mapStatetoProps = state => {
  const {
    layoutType,
    showRightSidebar,
    leftMenu,
    leftSideBarType,
  } = state.Layout;
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header));
